import { APICore } from "./apiCore";

const api = new APICore();

const criarHistorico = (params: object) => {
  return api.create("/historico", params);
};

const atualizarHistorico = (id: string | number, params: any) => {
  return api.update(`/historico/${id}`, params);
};

// fixar tem rota própria: o PUT só altera o conteúdo e marca o post como editado
const fixarHistorico = (id: string | number, fixado: boolean) => {
  return api.updatePatch(`/historico/${id}/fixar`, { fixado });
};

const deletarHistorico = (id: string) => {
  return api.delete(`/historico/${id}`);
};

const getHistoricos = (queryString?: string) => {
  return api.get(`/historico${queryString ? queryString : ""}`);
};

export {
  criarHistorico,
  atualizarHistorico,
  fixarHistorico,
  deletarHistorico,
  getHistoricos,
};
